import getAxios from './axiosService'
// import userService from './userService'

// const traceId = null // userService.getTraceId();

// function getUrl (route) {
//   // route += '?';
//   if (traceId) {
//     route += `User-Trace-Id=${traceId}`
//   }
//   return route
// }

const bookService = {
  getDetail (id) {
    return new Promise((resolve, reject) => {
      const axios = getAxios(true)
      axios.get(`/api/book/detail/${id}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            console.error(`Get book ${id} detail with error`, res)
            reject(res.data)
          }
        })
    })
  },
  getChapters (id, currentPage = 1) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios({
        method: 'post',
        url: `/api/book/catalogue?bookId=${id}&currentPage=${currentPage}`,
        data: {
          bookId: id
        },
        transformRequest: [
          function (data) {
            let ret = ''
            for (const item in data) {
              ret += `${encodeURIComponent(item)}=${encodeURIComponent(data[item])}&`
            }
            return ret
          }
        ]
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  getChapterImg (id, number) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.get(`api/book/read_chapter?bookId=${id}&number=${number}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  buyChapter (id) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.post('/api/book/chapter/buy', {}, {
        params: {
          chapterId: id
        }
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  }
}

export default bookService
